// extracted by mini-css-extract-plugin
export default {"timeRow":"EditScopeModal_timeRow__MkdU9","timeInput":"EditScopeModal_timeInput__+pOKI","ml":"EditScopeModal_ml__wkhlV"};